module.exports = __webpack_public_path__ + "img/Laptop.952e4d8.png";